var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408 1020c-108 0-209.6-42.4-285.6-118.4-157.6-157.6-157.6-415.2 0-572.8 76-76.8 177.6-118.4 285.6-118.4 108 0 209.6 42.4 285.6 118.4 157.6 157.6 157.6 415.2 0 572.8-76 76-177.6 118.4-285.6 118.4z m0-778.4c-99.2 0-192.8 39.2-263.2 109.6C0 496.8 0 733.6 144.8 878.4c70.4 70.4 164 109.6 263.2 109.6 99.2 0 192.8-39.2 263.2-109.6 144.8-145.6 144.8-382.4 0-528-70.4-69.6-164-108.8-263.2-108.8z",
    fill: "#0E1856"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M408 875.2c-69.6 0-134.4-27.2-183.2-76-101.6-101.6-101.6-266.4 0-368 48.8-48.8 114.4-76 183.2-76 69.6 0 134.4 27.2 183.2 76 101.6 101.6 101.6 266.4 0 368-48.8 48.8-113.6 76-183.2 76z m0-504.8c-64.8 0-126.4 25.6-172 71.2-95.2 95.2-95.2 250.4 0 345.6 46.4 46.4 107.2 71.2 172 71.2s126.4-25.6 172-71.2c95.2-95.2 95.2-250.4 0-345.6-45.6-45.6-107.2-71.2-172-71.2z",
    fill: "#0E1856"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M408 732c-31.2 0-60.8-12-82.4-34.4-45.6-45.6-45.6-120 0-165.6 22.4-22.4 51.2-34.4 82.4-34.4s60.8 12 82.4 34.4c45.6 45.6 45.6 120 0 165.6-21.6 22.4-51.2 34.4-82.4 34.4z m0-218.4c-27.2 0-52 10.4-71.2 29.6-39.2 39.2-39.2 103.2 0 143.2 19.2 19.2 44 29.6 71.2 29.6s52-10.4 71.2-29.6c39.2-39.2 39.2-103.2 0-143.2-19.2-19.2-44-29.6-71.2-29.6z",
    fill: "#0E1856"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M408 633.6c-4 0-8-1.6-11.2-4.8-6.4-6.4-6.4-16 0-22.4L784 218.4c6.4-6.4 16-6.4 22.4 0 6.4 6.4 6.4 16 0 22.4L419.2 628.8c-3.2 3.2-7.2 4.8-11.2 4.8z",
    fill: "#0E1856"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M780 260.8h-3.2c-5.6-0.8-9.6-4.8-12-9.6l-38.4-101.6c-2.4-5.6-0.8-12.8 4-16.8l122.4-123.2c4-4 9.6-5.6 14.4-4 5.6 0.8 9.6 4.8 12 9.6l38.4 101.6c2.4 5.6 0.8 12.8-4 16.8L791.2 256c-3.2 3.2-7.2 4.8-11.2 4.8zM760 147.2l26.4 68.8 97.6-97.6-26.4-68.8L760 147.2z",
    fill: "#0E1856"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M881.6 299.2c-1.6 0-4 0-5.6-0.8l-101.6-38.4c-4.8-1.6-8.8-6.4-9.6-11.2-0.8-5.6 0.8-11.2 4-14.4l122.4-123.2c4.8-4.8 11.2-5.6 16.8-4l101.6 38.4c4.8 1.6 8.8 6.4 9.6 11.2 0.8 5.6-0.8 11.2-4 14.4l-122.4 123.2c-3.2 3.2-7.2 4.8-11.2 4.8z m-72.8-60.8l68.8 26.4 97.6-98.4-68.8-26.4-97.6 98.4z",
    fill: "#0E1856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.2322fe45868cce2c4d2f4fe4dd86d62c.svg";
export { ForwardRef as ReactComponent };